var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('minePage',{attrs:{"info":{},"barTitle":"我的订单","barOptions":_vm.barOptions,"cellOptions":_vm.cellOptions},on:{"barChange":_vm.barChange,"cellChange":_vm.cellChange,"onBarTitle":_vm.onBarTitle}})}
var staticRenderFns = []

export { render, staticRenderFns }